<div class="modal-body">
  <form [formGroup]="filterForm">

    
    <ng-container *ngIf="mode === 'precios'">
        <app-multi-select
        style="grid-column: span 2;"
        [list]="branchMultiSelectList"
        listDisplay="name"
        placeholder="Sucursales"
        (selectedItems)="onBranchesSelected($event)"
      ></app-multi-select>
      

    </ng-container>

    <ng-container *ngIf="mode !== 'precios'">

      <div>
        <app-input [label]="'SKU ID'" formControlName="sku" ngDefaultControl></app-input>
      </div>

    <div>
      <app-input [label]="'Nombre del Producto'" formControlName="q" ngDefaultControl>
      </app-input>

    </div>
    <div *ngIf="mode === 'images'">
      <app-input [label]="'ID Producto'" formControlName="productId" ngDefaultControl></app-input>
    </div>
    <div >  <app-generic-select style="width: 300px;" [items]="categories" [placeholder]="'Categoría'"
      (selectionChange)="onCategorySelect($event)" [serverSideSearch]="true" (searchChange)="categorySearch$.next($event)"
      (cleared)="onCategorySelect(null)"   [showSearchIcon]="false"
      (loadMore)="loadMoreCategories()"
      >
    </app-generic-select>
    </div>

    <div  >
      <app-generic-select style="width: 300px;" [items]="brands" [placeholder]="'Marca'"
        (selectionChange)="onBrandSelect($event)"   [showSearchIcon]="false"
        (cleared)="onBrandSelect(null)" [serverSideSearch]="true" [showSearchIcon]="false" (searchChange)="brandSearch$.next($event)" (loadMore)="loadMoreBrands()">
      </app-generic-select>
    </div>

      <div>
        <app-generic-select
          style="width: 300px;"
          [items]="status"
          [placeholder]="'Status'"
          (selectionChange)="onStatusSelect($event)"
          (cleared)="onStatusSelect(null)"
          [showSearchIcon]="false"
        ></app-generic-select>
      </div>

    </ng-container>

  </form>
</div>

<div class="modal-footer">
  <button  *ngIf="mode !== 'precios'" (click)="handleClear()">Limpiar Filtros</button>
  <button  *ngIf="mode !== 'precios'" (click)="handleSearch()">Filtrar</button>
</div>
